import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reverse";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context11; _forEachInstanceProperty(_context11 = ownKeys(Object(source), true)).call(_context11, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context12; _forEachInstanceProperty(_context12 = ownKeys(Object(source))).call(_context12, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isArray, isFunction, isString } from 'lodash';

function resolveTargets(_ref) {
  var _context, _context2, _context3, _context4;

  var token = _ref.token,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? null : _ref$base,
      target = _ref.target,
      type = _ref.type;

  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var targets = _reverseInstanceProperty(_context = _filterInstanceProperty(_context2 = isArray(target) ? _toConsumableArray(target) : [target]).call(_context2, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context);

  var types = _reverseInstanceProperty(_context3 = _filterInstanceProperty(_context4 = isArray(type) ? _toConsumableArray(type) : [type]).call(_context4, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context3);

  return _reduceInstanceProperty(targets).call(targets, function (acc, target) {
    return _reduceInstanceProperty(types).call(types, function (acc, type) {
      var _context5;

      return token(_concatInstanceProperty(_context5 = "".concat(target, ".")).call(_context5, type), acc);
    }, acc);
  }, base);
}

function resolveTokenStyleValue(_ref2) {
  var token = _ref2.token,
      tokenKey = _ref2.tokenKey,
      value = _ref2.value;

  if (isString(value)) {
    var _context6;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token(_concatInstanceProperty(_context6 = "".concat(tokenKey, ".")).call(_context6, value));
  } else if (isFunction(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}

function resolveTextStyleValue(_ref3) {
  var token = _ref3.token,
      type = _ref3.type,
      tokenKey = _ref3.tokenKey,
      value = _ref3.value;

  if (isString(value)) {
    var _context7, _context8;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token(_concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "".concat(tokenKey, ".")).call(_context8, value, ".")).call(_context7, type));
  } else if (isFunction(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}

function resolveFallbacks(_ref4) {
  var _context9, _context10;

  var token = _ref4.token,
      type = _ref4.type,
      _ref4$base = _ref4.base,
      base = _ref4$base === void 0 ? null : _ref4$base,
      fallback = _ref4.fallback,
      tokenKey = _ref4.tokenKey,
      resolver = _ref4.resolver;

  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var fallbacks = _reverseInstanceProperty(_context9 = _filterInstanceProperty(_context10 = isArray(fallback) ? _toConsumableArray(fallback) : [fallback]).call(_context10, function (f) {
    return f !== null && f !== void 0 ? f : false;
  })).call(_context9);

  return _reduceInstanceProperty(fallbacks).call(fallbacks, function (acc, fallback) {
    var _resolver;

    return (_resolver = resolver({
      token: token,
      type: type,
      tokenKey: tokenKey,
      value: fallback
    })) !== null && _resolver !== void 0 ? _resolver : acc;
  }, resolver({
    token: token,
    type: type,
    tokenKey: tokenKey,
    value: base
  }));
}

function generateTokenFn(_ref5) {
  var target = _ref5.target,
      base = _ref5.base,
      type = _ref5.type,
      fallback = _ref5.fallback,
      tokenKey = _ref5.tokenKey,
      _ref5$resolver = _ref5.resolver,
      resolver = _ref5$resolver === void 0 ? resolveTokenStyleValue : _ref5$resolver;
  return function (_ref6) {
    var token = _ref6.token;
    return resolveTargets({
      token: token,
      target: target,
      type: type,
      base: resolveFallbacks({
        token: token,
        type: type,
        base: base,
        fallback: fallback,
        tokenKey: tokenKey,
        resolver: resolver
      })
    });
  };
}
/**
 * Create style keys for a specific `textStyle.*` token, to be spread
 * onto any style object within `StyleSheet`
 * @param {String} key
 * @return {Object}
 */


export var text = {
  styles: function styles() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref7.target,
        fallback = _ref7.fallback,
        color = _ref7.color,
        font = _ref7.font,
        lineHeight = _ref7.lineHeight,
        letterSpacing = _ref7.letterSpacing,
        textDecoration = _ref7.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: resolveTextStyleValue
    };

    var _ref8 = font || {},
        family = _ref8.family,
        size = _ref8.size,
        weight = _ref8.weight;

    return {
      color: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      fontFamily: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.family',
        fallback: [family, fallback]
      })),
      fontSize: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.size',
        fallback: [size, fallback]
      })),
      fontWeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.weight',
        fallback: [weight, fallback]
      })),
      lineHeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  },
  tokens: function tokens() {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref9.target,
        fallback = _ref9.fallback,
        color = _ref9.color,
        font = _ref9.font,
        lineHeight = _ref9.lineHeight,
        letterSpacing = _ref9.letterSpacing,
        textDecoration = _ref9.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: resolveTextStyleValue
    };

    var _ref10 = font || {},
        family = _ref10.family,
        size = _ref10.size,
        weight = _ref10.weight;

    return {
      color: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      font: {
        family: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.family',
          fallback: [family, fallback]
        })),
        size: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.size',
          fallback: [size, fallback]
        })),
        weight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.weight',
          fallback: [weight, fallback]
        }))
      },
      lineHeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  }
};
export var icon = {
  styles: function styles(_ref11) {
    var target = _ref11.target,
        color = _ref11.color,
        size = _ref11.size;
    return {
      color: generateTokenFn({
        target: target,
        type: 'icon.color',
        tokenKey: 'color.textStyle',
        fallback: color
      }),
      height: generateTokenFn({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      }),
      width: generateTokenFn({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      })
    };
  },
  tokens: function tokens(_ref12) {
    var target = _ref12.target,
        color = _ref12.color,
        size = _ref12.size,
        svg = _ref12.svg;
    return {
      icon: {
        color: generateTokenFn({
          target: target,
          type: 'icon.color',
          tokenKey: 'color.textStyle',
          fallback: color
        }),
        size: generateTokenFn({
          target: target,
          type: 'icon.size',
          tokenKey: 'icon.size',
          fallback: size
        }),
        svg: generateTokenFn({
          target: target,
          type: 'icon.svg',
          tokenKey: 'icon.svg',
          fallback: svg
        })
      }
    };
  }
};
export var padding = {
  styles: function styles() {
    var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref13.target,
        all = _ref13.all,
        x = _ref13.x,
        y = _ref13.y,
        top = _ref13.top,
        right = _ref13.right,
        bottom = _ref13.bottom,
        left = _ref13.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      paddingTop: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.top',
        fallback: [top, y, all]
      })),
      paddingRight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.right',
        fallback: [right, x, all]
      })),
      paddingBottom: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.bottom',
        fallback: [bottom, y, all]
      })),
      paddingLeft: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.left',
        fallback: [left, x, all]
      }))
    };
  },
  tokens: function tokens() {
    var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref14.target,
        all = _ref14.all,
        x = _ref14.x,
        y = _ref14.y,
        top = _ref14.top,
        right = _ref14.right,
        bottom = _ref14.bottom,
        left = _ref14.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      padding: {
        top: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.top',
          fallback: [top, y, all]
        })),
        right: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.right',
          fallback: [right, x, all]
        })),
        bottom: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.bottom',
          fallback: [bottom, y, all]
        })),
        left: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.left',
          fallback: [left, x, all]
        }))
      }
    };
  }
};
export var margin = {
  styles: function styles() {
    var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref15.target,
        all = _ref15.all,
        x = _ref15.x,
        y = _ref15.y,
        top = _ref15.top,
        right = _ref15.right,
        bottom = _ref15.bottom,
        left = _ref15.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      marginTop: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'margin.top',
        fallback: [top, y, all]
      })),
      marginRight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'margin.right',
        fallback: [right, x, all]
      })),
      marginBottom: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'margin.bottom',
        fallback: [bottom, y, all]
      })),
      marginLeft: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'margin.left',
        fallback: [left, x, all]
      }))
    };
  },
  tokens: function tokens() {
    var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref16.target,
        all = _ref16.all,
        x = _ref16.x,
        y = _ref16.y,
        top = _ref16.top,
        right = _ref16.right,
        bottom = _ref16.bottom,
        left = _ref16.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      margin: {
        top: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'margin.top',
          fallback: [top, y, all]
        })),
        right: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'margin.right',
          fallback: [right, x, all]
        })),
        bottom: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'margin.bottom',
          fallback: [bottom, y, all]
        })),
        left: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'margin.left',
          fallback: [left, x, all]
        }))
      }
    };
  }
};
export var border = {
  styles: function styles() {
    var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref17.target,
        all = _ref17.all,
        top = _ref17.top,
        right = _ref17.right,
        bottom = _ref17.bottom,
        left = _ref17.left;

    var widthShared = {
      target: target,
      tokenKey: 'border.width'
    };
    var styleShared = {
      target: target,
      base: function base() {
        return 'solid';
      },
      tokenKey: 'border.style'
    };
    var colorShared = {
      target: target,
      tokenKey: 'color.border'
    };
    var radiusShared = {
      target: target,
      tokenKey: 'border.radius'
    };

    var _ref18 = all || {},
        width = _ref18.width,
        style = _ref18.style,
        color = _ref18.color,
        radius = _ref18.radius;

    var _ref19 = top || {},
        topWidth = _ref19.width,
        topStyle = _ref19.style,
        topColor = _ref19.color,
        topRadius = _ref19.radius,
        topRight = _ref19.right,
        topLeft = _ref19.left;

    var _ref20 = topRight || {},
        topRightRadius = _ref20.radius;

    var _ref21 = topLeft || {},
        topLeftRadius = _ref21.radius;

    var _ref22 = right || {},
        rightWidth = _ref22.width,
        rightStyle = _ref22.style,
        rightColor = _ref22.color,
        rightRadius = _ref22.radius;

    var _ref23 = bottom || {},
        bottomWidth = _ref23.width,
        bottomStyle = _ref23.style,
        bottomColor = _ref23.color,
        bottomRadius = _ref23.radius,
        bottomRight = _ref23.right,
        bottomLeft = _ref23.left;

    var _ref24 = bottomRight || {},
        bottomRightRadius = _ref24.radius;

    var _ref25 = bottomLeft || {},
        bottomLeftRadius = _ref25.radius;

    var _ref26 = left || {},
        leftWidth = _ref26.width,
        leftStyle = _ref26.style,
        leftColor = _ref26.color,
        leftRadius = _ref26.radius;

    return {
      borderTopWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.top.width', 'border.width'],
        fallback: [topWidth, width]
      })),
      borderTopStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.top.style', 'border.style'],
        fallback: [topStyle, style]
      })),
      borderTopColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.top.color', 'border.color'],
        fallback: [topColor, color]
      })),
      borderTopRightRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.top.right.radius', 'border.top.radius', 'border.right.radius', 'border.radius'],
        fallback: [topRightRadius, topRadius, rightRadius, radius]
      })),
      borderTopLeftRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.top.left.radius', 'border.top.radius', 'border.left.radius', 'border.radius'],
        fallback: [topLeftRadius, topRadius, leftRadius, radius]
      })),
      borderRightWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.right.width', 'border.width'],
        fallback: [rightWidth, width]
      })),
      borderRightStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.right.style', 'border.style'],
        fallback: [rightStyle, style]
      })),
      borderRightColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.right.color', 'border.color'],
        fallback: [rightColor, color]
      })),
      borderBottomWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.bottom.width', 'border.width'],
        fallback: [bottomWidth, width]
      })),
      borderBottomStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.bottom.style', 'border.style'],
        fallback: [bottomStyle, style]
      })),
      borderBottomColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.bottom.color', 'border.color'],
        fallback: [bottomColor, color]
      })),
      borderBottomRightRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.bottom.right.radius', 'border.bottom.radius', 'border.right.radius', 'border.radius'],
        fallback: [bottomRightRadius, bottomRadius, rightRadius, radius]
      })),
      borderBottomLeftRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.bottom.left.radius', 'border.bottom.radius', 'border.left.radius', 'border.radius'],
        fallback: [bottomLeftRadius, bottomRadius, leftRadius, radius]
      })),
      borderLeftWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.left.width', 'border.width'],
        fallback: [leftWidth, width]
      })),
      borderLeftStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.left.style', 'border.style'],
        fallback: [leftStyle, style]
      })),
      borderLeftColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.left.color', 'border.color'],
        fallback: [leftColor, color]
      }))
    };
  },
  tokens: function tokens() {
    var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref27.target,
        all = _ref27.all,
        top = _ref27.top,
        right = _ref27.right,
        bottom = _ref27.bottom,
        left = _ref27.left;

    var widthShared = {
      target: target,
      tokenKey: 'border.width'
    };
    var styleShared = {
      target: target,
      base: function base() {
        return 'solid';
      },
      tokenKey: 'border.style'
    };
    var colorShared = {
      target: target,
      tokenKey: 'color.border'
    };
    var radiusShared = {
      target: target,
      tokenKey: 'border.radius'
    };

    var _ref28 = all || {},
        width = _ref28.width,
        style = _ref28.style,
        color = _ref28.color,
        radius = _ref28.radius;

    var _ref29 = top || {},
        topWidth = _ref29.width,
        topStyle = _ref29.style,
        topColor = _ref29.color,
        topRadius = _ref29.radius,
        topRight = _ref29.right,
        topLeft = _ref29.left;

    var _ref30 = topRight || {},
        topRightRadius = _ref30.radius;

    var _ref31 = topLeft || {},
        topLeftRadius = _ref31.radius;

    var _ref32 = right || {},
        rightWidth = _ref32.width,
        rightStyle = _ref32.style,
        rightColor = _ref32.color,
        rightRadius = _ref32.radius;

    var _ref33 = bottom || {},
        bottomWidth = _ref33.width,
        bottomStyle = _ref33.style,
        bottomColor = _ref33.color,
        bottomRadius = _ref33.radius,
        bottomRight = _ref33.right,
        bottomLeft = _ref33.left;

    var _ref34 = bottomRight || {},
        bottomRightRadius = _ref34.radius;

    var _ref35 = bottomLeft || {},
        bottomLeftRadius = _ref35.radius;

    var _ref36 = left || {},
        leftWidth = _ref36.width,
        leftStyle = _ref36.style,
        leftColor = _ref36.color,
        leftRadius = _ref36.radius;

    return {
      border: {
        top: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.top.width', 'border.width'],
            fallback: [topWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.top.style', 'border.style'],
            fallback: [topStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.top.color', 'border.color'],
            fallback: [topColor, color]
          })),
          right: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.top.right.radius', 'border.top.radius', 'border.right.radius', 'border.radius'],
              fallback: [topRightRadius, topRadius, rightRadius, radius]
            }))
          },
          left: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.top.left.radius', 'border.top.radius', 'border.left.radius', 'border.radius'],
              fallback: [topLeftRadius, topRadius, leftRadius, radius]
            }))
          }
        },
        right: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.right.width', 'border.width'],
            fallback: [rightWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.right.style', 'border.style'],
            fallback: [rightStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.right.color', 'border.color'],
            fallback: [rightColor, color]
          }))
        },
        bottom: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.bottom.width', 'border.width'],
            fallback: [bottomWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.bottom.style', 'border.style'],
            fallback: [bottomStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.bottom.color', 'border.color'],
            fallback: [bottomColor, color]
          })),
          right: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.bottom.right.radius', 'border.bottom.radius', 'border.right.radius', 'border.radius'],
              fallback: [bottomRightRadius, bottomRadius, rightRadius, radius]
            }))
          },
          left: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.bottom.left.radius', 'border.bottom.radius', 'border.left.radius', 'border.radius'],
              fallback: [bottomLeftRadius, bottomRadius, leftRadius, radius]
            }))
          }
        },
        left: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.left.width', 'border.width'],
            fallback: [leftWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.left.style', 'border.style'],
            fallback: [leftStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.left.color', 'border.color'],
            fallback: [leftColor, color]
          }))
        }
      }
    };
  }
};
export var focus = {
  styles: function styles(_ref37) {
    var target = _ref37.target,
        shadow = _ref37.shadow;
    return {
      outline: 'none',
      boxShadow: generateTokenFn({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref38) {
          var token = _ref38.token;
          return token('shadow.focus');
        }
      })
    };
  },
  tokens: function tokens(_ref39) {
    var target = _ref39.target,
        shadow = _ref39.shadow;
    return {
      shadow: generateTokenFn({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref40) {
          var token = _ref40.token;
          return token('shadow.focus');
        }
      })
    };
  }
};